import PercentageIcon from '../../../../assets/icons/percentage.svg?react';
import DashboardSharedTable from '../../components/common/DashboardSharedTable';
import useCommissionPayout from '../hooks/useCommissionPayout';
import { useCompanyFilterContext } from '../../components/context/CompanyFilterContext';
import { formatCurrency } from '@demandproai/shared';
import { statCardClasses } from '../../../../components/common/dashboardClasses';
import { costTotalTextClasses } from '../../../../components/common/dashboardGridClasses';

const CommissionPayout = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedAccountExecutive, selectedCompanies } = filterParams;

    const { monthlyData, totalCommission } = useCommissionPayout({ selectedRange, selectedAccountExecutive, selectedCompanies });

    const columns = [
        { header: 'Month',               dataKey: 'monthName' },
        { header: 'Generated Sales',     render: (row) => `$${formatCurrency(row.totalSales)}` },
        { header: 'Type',                render: (row) => row.isAnnual ? 'Annual' : 'Monthly' },
        { header: 'Commission Rate',     render: (row) => `${row.commissionRate}%${row.isAnnual ? ' (12x)' : ''}` },
        { header: 'Expected Commission', render: (row) => `$${formatCurrency(row.expectedCommission)}` },
    ];

    return (
        <DashboardSharedTable
            title="Monthly Commission Payout"
            icon={<PercentageIcon />}
            headerExtra={<span className={costTotalTextClasses}>Total <strong>${formatCurrency(totalCommission)}</strong></span>}
            columns={columns}
            data={monthlyData}
            className={statCardClasses}
        />
    );
};

export default CommissionPayout;
